import type { SubscriptionPageConfig } from 'fitify-ui-onboarding/src/types/subscription'
import type { MetaDataProps } from 'fitify-ui-onboarding/src/utils/meta-tags'
import { useTranslation } from 'next-i18next/pages'

import { PageTitle } from 'components/PageTitle'
import { SubscriptionContent } from 'sections/subscription/Content/SubscriptionContent'
import { Layout } from 'sections/subscription/Layout/Layout'

type Props = {
  metaData?: MetaDataProps
  pageConfig?: SubscriptionPageConfig
}

export const SubscriptionPageLoader = ({ metaData, pageConfig }: Props) => {
  const { t } = useTranslation()

  return (
    <Layout pageConfig={pageConfig}>
      <PageTitle
        title={
          pageConfig?.planTitle || t('paywall_your_plan_is_ready_calisthenics')
        }
        metaData={metaData}
        canonical
      />
      <SubscriptionContent pageConfig={pageConfig} />
    </Layout>
  )
}
